module.exports = __webpack_public_path__ + "img/204.dd3e3a9f.png";